var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2688",
    "data-name": "Group 2688",
    transform: "translate(-361 -592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nedladdning_41_",
    "data-name": "nedladdning (41)",
    transform: "translate(364.725 593.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4678",
    "data-name": "Path 4678",
    d: "M240.813,172.891a4.989,4.989,0,0,0,2.875-4.773c0-2.743-1.021-5.145-1.739-5.225a.691.691,0,0,0-.8.742v4.358a.524.524,0,0,1-.536.51h-.032a.524.524,0,0,1-.536-.51v-4.358a.767.767,0,0,0-.785-.742h-.241a.767.767,0,0,0-.785.742v4.358a.524.524,0,0,1-.536.51h-.032a.524.524,0,0,1-.536-.51v-4.358a.691.691,0,0,0-.8-.742c-.719.081-1.739,2.482-1.739,5.225a4.989,4.989,0,0,0,2.875,4.773.5.5,0,0,1,.316.435l-.337,9.937a1.7,1.7,0,0,0,3.4,0l-.337-9.937a.5.5,0,0,1,.316-.436Z",
    transform: "translate(-234.582 -162.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4679",
    "data-name": "Path 4679",
    d: "M431.051,184.87h.047a1.472,1.472,0,0,0,1.529-1.411V163.676a1.217,1.217,0,0,0-.114-.595c-.8-1.162-4.64,3.071-4.9,7.361,0,2.047.219,3.718,1.867,4.419a.489.489,0,0,1,.3.423l-.221,8.17a1.431,1.431,0,0,0,1.491,1.415Z",
    transform: "translate(-416.85 -162.886)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(361 592)",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFork);
export default __webpack_public_path__ + "static/media/Fork.adf256c7e473f2df1bd79dc5d2abd55b.svg";
export { ForwardRef as ReactComponent };